import AuthenticationForm from "components/Authentication/AuthenticationForm";
import { isValidPhone } from "components/Authentication/fieldValidators";
import { useState } from "react";

interface StepProfileProps {
  data: any;
  error: Record<string, string> | null;
  onNext: (values: any) => void;
  onBack: () => void;
}

export default function StepProfile({
  data,
  error,
  onNext,
  onBack,
}: StepProfileProps) {
  const [localError, setLocalError] = useState<Record<string, string> | null>(null);

  function handleNext(values: any) {
    const errors: Record<string, string> = {};

    if (!values.first_name?.trim()) {
      errors.first_name = "First name is required.";
    }

    if (!values.last_name?.trim()) {
      errors.last_name = "Last name is required.";
    }

    if (values.phone_number && !isValidPhone(values.phone_number)) {
      errors.phone_number =
        "Please enter a valid phone number (digits, spaces, +, -, or parentheses).";
    }

    if (Object.keys(errors).length > 0) {
      setLocalError(errors);
      return;
    }

    setLocalError(null);
    onNext({
      ...values,
      first_name: values.first_name.trim(),
      last_name: values.last_name.trim(),
      role: 1,
      permissions: [1],
    });
  }

  return (
    <AuthenticationForm
      title="Profile Information"
      submitLabel="Next"
      error={{ ...(error || {}), ...(localError || {}) }}
      onBack={onBack}
      fields={[
        { name: "first_name", label: "First Name", required: true },
        { name: "last_name", label: "Last Name", required: true },
        { name: "phone_number", label: "Phone Number" },
        { name: "department", label: "Department" },
        { name: "position_title", label: "Position Title" },
      ]}
      initialValues={data}
      onSubmit={handleNext}
    />
  );
}